var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0024 5.5001L5.19298 13.4407C4.93445 13.7261 4.79553 14.0999 4.80501 14.4848C4.81449 14.8697 4.97163 15.2363 5.2439 15.5086C5.51617 15.7808 5.88271 15.938 6.26764 15.9474C6.65257 15.9569 7.0264 15.818 7.31174 15.5595L16.6211 6.11885C17.1382 5.54817 17.416 4.80051 17.3971 4.03065C17.3781 3.26079 17.0638 2.52771 16.5193 1.98317C15.9748 1.43864 15.2417 1.12436 14.4718 1.1054C13.7019 1.08645 12.9543 1.36427 12.3836 1.88135L3.07423 11.322C2.23134 12.1649 1.75781 13.3081 1.75781 14.5001C1.75781 15.6921 2.23134 16.8353 3.07423 17.6782C3.91713 18.5211 5.06033 18.9946 6.25236 18.9946C7.44439 18.9946 8.58759 18.5211 9.43049 17.6782L17.1274 10.0001",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.708857d0e9332694b0b25b2859bfb0d2.svg";
export { ForwardRef as ReactComponent };